import { CSSProperties } from "react"
import useScreen from "Hooks/useScreen"
import { clsx, styx } from "modules/Utils"
import Lottie from "react-lottie"
import SymphonyLoadingLottie from 'assets/images/lotties/SymphonyLoading_White.json';
import SymphonyLoadingLottieBlack from 'assets/images/lotties/SymphonyLoading.json';
import { createPortal } from 'react-dom';
import { NAV_BAR_WIDTH_COLLAPSED, NAV_BAR_WIDTH_EXPANDED } from "modules/Const";
import { useNavbar } from "Hooks/useNavbar";
import Colors from "modules/Colors";
import Loader from "./Loader";

interface LoaderOverlayProps {
    className: string,
    color?: string | 'white' | 'purple'
    title?: string
    isNavbar?: boolean
    isTransparent?: boolean
    children?: React.ReactNode
}

const LoaderOverlay = ({
    className,
    color = 'white',
    title = 'Loading...',
    isNavbar = false,
    isTransparent = false,
    children,
}: LoaderOverlayProps): JSX.Element | null => {
    const { cssCalc, mobileView } = useScreen()
    const { isCollapsed } = useNavbar()

    return createPortal(
        <div
            className={clsx(
                'loaderOverlayElement',
                className
            )}
            style={styx(
                sty.loaderOverlayElement,
                { height: cssCalc() },
                isNavbar && !mobileView && { paddingLeft: isCollapsed ? NAV_BAR_WIDTH_COLLAPSED : NAV_BAR_WIDTH_EXPANDED },
                !isTransparent && { backgroundColor: Colors.purple }
            )}
        >
            <Loader
                size={44}
                color="white"
            />
            <div style={sty.loaderTitle}>
                {title}
            </div>
            {children}
        </div>,
        document.body
    )
}

const sty: Record<string, CSSProperties> = {
    loaderOverlayElement: {
        position: 'absolute',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        top: 0,
        left: 0,
        width: '100%',
        backgroundColor: 'rgba(44, 33, 53, 0.6)',
        zIndex: 2000,
    },
    loaderTitle: {
        fontSize: 18,
        color: 'white',
    }
}

export default LoaderOverlay;